module.exports = __webpack_public_path__ + "assets/playStore-5119b4.svg";